import { memo } from 'react';
import isEqual from 'react-fast-compare';
import UploadArticle from './UploadArticle.jsx';
import { hooks } from '@/store.js';

const UploadImages = memo(
  ({
    id,
    onCancel,
    onSuccess,
    list,
  }: {
    id: string;
    onCancel: () => void;
    onSuccess: () => void;
    list: string[];
  }) => {
    const client = hooks.useClient();

    if (!list?.length) return null;

    return (
      <div className='mt-5 flex'>
        {list.map((i) => (
          <UploadArticle
            className='mr-2.5'
            key={i}
            defaultValue={
              i.startsWith('http') || i === 'CHOOSE'
                ? i
                : `https://trip-qiniu.pmlife.top/${i}?imageView2/2/w/96/h/96`
            }
            onCancel={onCancel}
            onDelete={async () => {
              // STEP: 服务器删除
              const record = await client.events.get(id).resolved;

              await record?.set(
                'images',
                (record.get('images') || []).filter((n) => n !== i)
              );
            }}
            onSave={async ({ url }) => {
              // STEP: 保存
              const record = await client.events.get(id).resolved;
              await record?.set('images', [
                ...(record.get('images') || []),
                url,
              ]);
              onSuccess();
            }}
          />
        ))}
      </div>
    );
  },
  isEqual
);

export default UploadImages;
